import styled from 'styled-components';

export const WrapperStyled = styled.div`
  min-width: 100px;
  width: 100%;
  position: relative;
  .setur-slider-handle {
    &:before {
      background-color: ${({ theme }) => theme.palette.primaryBrand} !important;
      border-radius: 50%;

      z-index: 1;
      border: 4px solid ${({ theme }) => theme.palette.white};
    }
    &:after {
      display: none;
    }
  }
`;

export const SectionTitleStyled = styled.h1`
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
